const ROBOTS_META_NAME = 'robots';
const INDEXABLE_CONTENT = 'index, follow';
const DEFAULT_CONTENT = 'noindex, follow';

function getRobotsMeta() {
  let meta = document.querySelector(`meta[name="${ROBOTS_META_NAME}"]`);

  if (meta == null) {
    meta = document.createElement('meta');
    meta.setAttribute('name', ROBOTS_META_NAME);
    document.head.appendChild(meta);
  }

  return meta;
}

function isIndexableRoute(route) {
  return route != null && route.meta != null && route.meta.indexable === true;
}

export function updateRobotsMeta(route) {
  if (typeof document === 'undefined') {
    return;
  }

  const meta = getRobotsMeta();
  const content = isIndexableRoute(route) ? INDEXABLE_CONTENT : DEFAULT_CONTENT;

  meta.setAttribute('content', content);
}
